var _use, _use2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCross = function SvgCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 15"
  }, props), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cross_svg__a",
    fill: "currentColor",
    transform: "scale(1.00443 .99555)rotate(-45 2.61 -1.228)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Cross_svg__a",
    fill: "currentColor",
    transform: "scale(-1.00443 -.99555)rotate(45 16.28 -9.052)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "Cross_svg__a",
    d: "M-1 0v17.92h2V0z"
  }))));
};
export default SvgCross;